// チャートの系列色。凡例をチャート外（テーブルの色見本など）に置く場合も同じ色を使う
export const PIE_CHART_COLORS = ['#6ECBFA', '#FFB800', '#EAF200', '#8B5CF6']

// 上限を超えた系列をまとめる「その他」の色
export const OTHERS_COLOR = '#D1D5DB'

// 縦棒・横棒グラフの系列色
export const BAR_CHART_COLORS = ['#6ECBFA', '#FFB800', '#EAF200', '#8B5CF6', '#EC4899']
